export default {"src":"/_next/static/media/humana-logo.71c2361d.svg","height":26,"width":105,"blurWidth":0,"blurHeight":0};